const experienceData = [
  {
    id: 1,
    startDate: "SEP 2023",
    endDate: "MAY 2025",
    company: "Правильное решение",
    position: "Тимлид.",
    description: "Создание, развитие\nи поддержание айдентики\n3* брендов.",
  },
  {
    id: 2,
    startDate: "AUG 2022",
    endDate: "SEP 2023",
    company: "ЛЕНТА",
    position: "Графический дизайнер.\nSMM дизайнер.",
    description: null,
  },
  {
    id: 3,
    startDate: "SEP 2019",
    endDate: "JUN 2022",
    company: "РОССИЙСКАЯ\nАКАДЕМИЯ ХУДОЖЕСТВ",
    position: "Мозаист.",
    description: "Проект для Храма\nСвятого Саввы Сербского\nв Белграде.",
  },
  {
    id: 4,
    startDate: "MAY 2019",
    endDate: "NOW",
    company: "Фриланс",
    position: "Графический дизайнер.",
    description:
      "Создание айдентики,\nиллюстраций, проектирование\nупаковки, анимация.",
  },
  {
    id: 5,
    startDate: "SEP 2018",
    endDate: "MAY 2019",
    company: "Репетитор",
    position: "Репетитор",
    description:
      "по рисунку и живописи.\nПодготовка абитуриентов\nк поступлению\nв художественные ВУЗы.",
  },
];

export default experienceData;
